<!-- <app-layout> -->
  <app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<!-- <div class="d-flex m-0 align-items-center">
  <h3 class="ms-2 mt-2">Bozze salvate</h3>
</div> -->

<div class="d-flex mt-3 ms-1 mb-2 justify-content-between align-items-center hidden-mobile">
  <h3>Bozze salvate</h3>
  <div class="me-1 custom-select-wrapper year-select">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select
        class="izy-select-trigger"
        panelClass="izy-select-panel"
        [(value)]="selectedYear"
        (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="w-100 mb-2 visible-mobile custom-rounded">
  <div class="custom-select-wrapper year-select">
    <mat-form-field appearance="fill" class="mb-0 w-100 custom-rounded" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select
        class="custom-rounded izy-select-trigger"
        panelClass="izy-select-panel"
        [(value)]="selectedYear"
        (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<h3 class="ms-1 visible-mobile">Bozze salvate</h3>

<!-- <mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column text-button-card custom-card">
  <div class="d-flex justify-content-between align-items-center mb-0">
    <button
      class="ms-auto"
      matButton="filled"
      color="primary"
      (click)="navigateToNewInvoice()"
    >
    <mat-icon>add</mat-icon>
      New Invoice
    </button>
  </div>
</mat-card> -->

<!-- filter panel -->
<mat-accordion class="me-0 col-md-12 d-flex flex-column">
  <mat-expansion-panel
    [(expanded)]="filterPanelOpenState"
    class="izy-fields izy-filter-panel izy-sharp-bl">
    <mat-expansion-panel-header class="izy-filter-header">
      <mat-panel-title class="izy-filter-title">
        <span class="izy-filter-icon">
          <mat-icon>filter_list</mat-icon>
        </span>
        <span class="ms-2">Filtri</span>
      </mat-panel-title>
      <mat-panel-description *ngIf="!filterPanelOpenState">
        <span
          class="izy-filter-count"
          [ngClass]="{'izy-filter-count--active': getActiveFilterCount() > 0}">
          {{ getActiveFilterCount() }} filtri attivi
        </span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- Basic Filters -->
    <div class="row w-100">
      <!-- Amount Range -->
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo minimo</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="filters.amount_gt"
            name="amount_gt"
          />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo massimo</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="filters.amount_lt"
            name="amount_lt"
          />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Data di emissione da</mat-label>
        <input
          matInput
          [matDatepicker]="emissionStartPicker"
          [(ngModel)]="filters.emission_date_after"
          name="emission_date_after"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionStartPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionStartPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Data di emissione a</mat-label>
        <input
          matInput
          [matDatepicker]="emissionEndPicker"
          [(ngModel)]="filters.emission_date_before"
          name="emission_date_before"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionEndPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionEndPicker></mat-datepicker>
      </mat-form-field>
    
    </div>

    <!-- Advanced Filters Toggle -->
    <!-- <mat-slide-toggle [(ngModel)]="advancedFilters" class="mb-0">
      Filtri avanzati
    </mat-slide-toggle> -->

    <!-- Advanced Filters (hidden by default) -->
    <div class="advanced-filters" *ngIf="advancedFilters">
      <mat-divider class="my-3"></mat-divider>

      <div class="row w-100 mb-0">
        <!-- Emission Date Range -->
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di emissione da</mat-label>
            <input
              matInput
              [matDatepicker]="emissionStartPicker"
              [(ngModel)]="filters.emission_date_after"
              name="emission_date_after"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di emissione a</mat-label>
            <input
              matInput
              [matDatepicker]="emissionEndPicker"
              [(ngModel)]="filters.emission_date_before"
              name="emission_date_before"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Payment Date Range -->
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>>Data di pagamento da</mat-label>
            <input
              matInput
              [matDatepicker]="paymentStartPicker"
              [(ngModel)]="filters.payment_date_after"
              name="payment_date_after"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="paymentStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #paymentStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di pagamento a</mat-label>
            <input
              matInput
              [matDatepicker]="paymentEndPicker"
              [(ngModel)]="filters.payment_date_before"
              name="payment_date_before"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="paymentEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #paymentEndPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="izy-filter-actions d-flex justify-content-end gap-2 mt-2 w-sm-100">
      <button
        mat-stroked-button
        class="izy-button-ghost izy-button-ghost--warn custom-button-border"
        (click)="resetFilters()">
        <mat-icon>clear</mat-icon>
        Cancella
      </button>
      <button
        matButton="filled"
        class="izy-button-primary custom-button-border"
        (click)="loadInvoices()">
        <mat-icon>search</mat-icon>
        Applica filtri
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- Colored cards -->
<!-- <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-2 mt-3 mb-3 hidden-mobile">
  <mat-card class="flex-grow-1 d-flex flex-column clickable-yellow custom-card-yellow">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ totalInvoices }}</span>Total Invoices
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <mat-card class="flex-grow-1 d-flex flex-column clickable-blue custom-card-blue">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ paidInvoices }}</span>Paid Invoices
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <mat-card class="flex-grow-1 d-flex flex-column clickable-pink custom-card-pink">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ totalInvoices - paidInvoices }}</span>
        Unpaid Invoices
      </mat-card-title>
    </mat-card-header>
  </mat-card>
</div> -->

<div class="mt-3 mb-3 d-flex justify-content-between align-items-center">
  <!-- Filter chips -->
  <mat-chip-set aria-label="Filter selection" class="flex-grow-1 status-chip-set">
    <mat-chip-option
      *ngFor="let option of filterOptions"
      [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyFilter(option.value)"
    >
      {{option.name}}
    </mat-chip-option>
  </mat-chip-set>

  <button
    (click)="navigateToNewInvoice()"
    class="ms-3 flex-shrink-0 izy-button-primary custom-button-border"
    matButton="filled"
  >
    <mat-icon>add</mat-icon>
    Nuova
  </button>
</div>

<!-- with this we can add a loading state -->
<!-- <div *ngIf="isLoading">Loading invoices...</div> -->

<mat-card
  class="mb-3 mb-md-0 col-md-12 d-flex flex-column custom-card izy-sharp-bl hidden-mobile"
>
  <mat-card-content>
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricando bozze...</p>
    </div>
    <!-- Show empty state when no data -->
    <div *ngIf="dataSource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
      <img 
        src="izy_image_5_small.png" 
        alt="Nessun cliente"
        class="empty-state-image mb-3"
        style="max-width: 300px; opacity: 1;"
      >
      <h4 class="text-muted">Ancora nessuna fattura qui...</h4>
      <p class="text-muted">Inizia a fatturare!</p>
    </div>

    <table
    *ngIf="dataSource.filteredData.length > 0"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8 hidden-mobile"
    >
      <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

      <!-- Actions Column -->
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef class="text-center">Azioni</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <button
            mat-icon-button
            class="izy-row-actions-btn"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            aria-label="Altre azioni"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="izy-menu-panel" xPosition="before">
            <!-- Gruppo 1: consultazione -->
            <button mat-menu-item (click)="onRowClick(element)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <button mat-menu-item (click)="openCustomerPage(element)">
              <mat-icon>account_box</mat-icon>
              <span>Vedi cliente</span>
            </button>
            <div class="izy-menu-sep"></div>
            <!-- Gruppo 2: download e pubblicazione -->
            <button mat-menu-item (click)="downloadPdf(element.id)">
              <mat-icon>download</mat-icon>
              <span>Vedi PDF</span>
            </button>
            <button mat-menu-item (click)="publishDraft(element)">
              <mat-icon>send</mat-icon>
              <span>Pubblica</span>
            </button>
            <!-- TODO: duplicate invoice ?  -->
            <!-- <button mat-menu-item (click)="navigateToNewInvoice()">
              <mat-icon>copy_all</mat-icon>
              <span>Duplica</span>
            </button> -->
            <!-- Gruppo 3: azione distruttiva -->
            <div class="izy-menu-sep"></div>
            <button mat-menu-item (click)="deleteInvoice(element)" class="text-danger">
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="document_type">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by document type"
        >
          Tipo
        </th>
        <td mat-cell *matCellDef="let element">{{ getDocumentTypeName(element.document_type!) }}{{ element.paper_invoice ? ' (cartacea)' : '' }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="invoice_name">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Name"
        >
          Nome
        </th>
        <td mat-cell *matCellDef="let element">{{element.invoice_name}}</td>
      </ng-container> -->

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Amount"
        >
          Importo
        </th>
        <td mat-cell *matCellDef="let element" class="amount-cell">{{element.amount | currency:newInvoice.currency:'symbol':'1.2-2' }}</td>
      </ng-container>

      <!-- Company Platform Column -->
      <!-- <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef>Valuta</th>
        <td mat-cell *matCellDef="let element">{{element.currency}}</td>
      </ng-container> -->

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let element">
          {{element.company.company_name}}
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descrizione</th>
        <td mat-cell *matCellDef="let element">{{element.description}}</td>
      </ng-container>

      <!-- Emission date Column -->
      <ng-container matColumnDef="emission_date">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Emission"
        >
          Data di emissione
        </th>
        <td mat-cell *matCellDef="let element">{{element.emission_date | date:'dd/MM/yyyy'}}</td>
      </ng-container>

      <!-- Publish Column -->
      <ng-container matColumnDef="Publish">
        <th mat-header-cell *matHeaderCellDef class="text-center">Pubblica</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <button
            mat-stroked-button
            class="invoice-details-btn custom-button-border"
            (click)="publishDraftWithStop($event, element)">
          <mat-icon
            (click)="publishDraftWithStop($event, element)"
            >send</mat-icon>
            Pubblica
          </button>
        </td>
      </ng-container>

      <!-- Is paid Column -->
      <!-- <ng-container matColumnDef="is_paid">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by Is Paid"
        >
          Is paid
        </th>
        <td mat-cell *matCellDef="let element">{{element.is_paid}}</td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
        (mouseenter)="onRowHover(row)"
        [matTooltip]="getRowTooltip(row)"
        matTooltipClass="row-summary-tooltip"
        matTooltipPosition="above"
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      ></tr>
    </table>

    <!-- Add the paginator at the bottom of the table -->
    <mat-paginator
      [pageSizeOptions]="[10, 20, 50, 100]"
      [pageSize]="20"
      showFirstLastButtons
      [selectConfig]="{ panelClass: 'izy-select-panel' }"
      class="hidden-mobile pt-2 pb-2"
    >
    </mat-paginator>

    <mat-divider class="visible-mobile"></mat-divider>
  </mat-card-content>
</mat-card>

<!-- Mobile Cards -->
<div class="mobile-cards visible-mobile">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricando bozze...</p>
  </div>
  <!-- Empty state for mobile -->
  <div *ngIf="filteredInvoices.length === 0 && !isLoading" class="empty-state text-center py-5">
    <img 
      src="izy_image_5_small.png" 
      alt="Nessun cliente"
      class="empty-state-image mb-3"
      style="max-width: 250px; opacity: 1;"
    >
    <h4 class="text-muted">Ancora nessuna fattura qui...</h4>
      <p class="text-muted">Inizia a fatturare!</p>
  </div>

  <mat-card *ngFor="let item of filteredInvoices" class="izy-sharp-bl custom-card-border">

    <mat-card-header class="d-flex mb-1 justify-content-between align-items-center w-100 mobile-header">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h6 class="mb-1 text-start"><strong>{{item.company.company_name || 'N/A'}}</strong></h6>
        <h6 class="mb-1 text-end"><strong>{{item.amount | currency:item.currency:'symbol':'1.2-2' }}</strong></h6>
      </div>
    </mat-card-header>

    <mat-card-content>

      <div class="d-flex m-0 justify-content-between align-items-center">
        <p class="mb-1 text-small"> {{item.document_type || 'Fattura'}} N.{{item.progressive_number || ''}} del {{item.emission_date | date:'dd/MM/yyyy'}}</p>
        <!-- Right arrow icon -->
        <button
          mat-icon-button
          class="izy-row-actions-btn"
          [matMenuTriggerFor]="menu"
          aria-label="Altre azioni"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
          <mat-menu #menu="matMenu" class="izy-menu-panel" xPosition="before">
            <!-- Gruppo 1: consultazione -->
            <button mat-menu-item (click)="onRowClick(item)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <button mat-menu-item (click)="openCustomerPage(item)">
              <mat-icon>account_box</mat-icon>
              <span>Vedi cliente</span>
            </button>
            <div class="izy-menu-sep"></div>
            <!-- Gruppo 2: download e pubblicazione -->
            <button mat-menu-item (click)="downloadPdf(item.id)">
              <mat-icon>download</mat-icon>
              <span>Vedi PDF</span>
            </button>
            <button mat-menu-item (click)="publishDraft(item)">
              <mat-icon>send</mat-icon>
              <span>Pubblica</span>
            </button>
            <!-- Gruppo 3: azione distruttiva -->
            <div class="izy-menu-sep"></div>
            <button mat-menu-item (click)="deleteInvoice(item)" class="text-danger">
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
      </div>

      <!-- <p><strong>Data:</strong> {{item.emission_date | date:'dd/MM/yyyy'}}</p>
      <p><strong>Company:</strong> {{item.company.company_name || 'N/A'}}</p>
      <p><strong>Amount:</strong> {{item.amount}} {{item.currency}}</p> -->
      <!-- <mat-chip-list>
        <mat-chip>
          {{item.is_paid ? 'Paid' : 'Unpaid'}}
        </mat-chip>
      </mat-chip-list> -->
    </mat-card-content>

      <div class="d-flex mt-0 mb-0 justify-content-between align-items-center invoice-card-footer">

        <div class="ms-0 d-flex align-items-center paid-toggle">
          <mat-chip
            color="primary"
            class="me-0 ms-2 status-chip"
          >
          Bozza
          </mat-chip>
        </div>

        <div>
          <button mat-stroked-button class="me-1 invoice-details-btn custom-button-border">
          <mat-icon
            (click)="publishDraftWithStop($event, item)"
            class="me-0 m-0"
            >send</mat-icon>
          </button>

          <button mat-stroked-button (click)="onRowClick(item)" class="me-2 invoice-details-btn custom-button-border">
            <div class="d-flex justify-content-between align-items-center">
            <p class="mb-0">Apri</p>
            <span>
              <mat-icon class="ms-3 mt-1 m-0 me-0">chevron_right</mat-icon>
            </span>
            </div>
          </button>
        </div>

      </div>

  </mat-card>

  <!-- Update paginator to use filteredInvoices length -->
  <!-- <mat-paginator
    [length]="filteredInvoices.length"
    [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10"
    showFirstLastButtons
  >
  </mat-paginator> -->
</div>

<div class="pt-3 mb-3"></div>
